<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Tipologia domanda #' + this.$route.params.id : 'Nuova tipologia domanda')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="tipologia">Tipologia:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipodomanda.tipologia" id="tipologia" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="tipodomanda.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipodomanda.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="tipodomanda.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipodomanda.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="tipodomanda.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            tipodomanda: {
                id: this.$route.params.id || null,
                tipologia: '',
                datains: null,
                uteins: ''
            },                    
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,                 
        };
    },
    methods: {                
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

        insert() {

            if (this.tipodomanda.tipologia == "") {
                this.showerror = true;
                this.error = "Campo tipologia vuoto!";               

            } else {

                this.tipodomanda.tipologia = this.tipodomanda.tipologia.toUpperCase();

                var json = JSON.stringify(this.tipodomanda);

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/tipodomanda', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.tipodomanda = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettagliotipologia/' + this.tipodomanda.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        }
    },
    created: function () {
        
        if(!ctrlVismenu("Q")){
            this.$router.replace('/accessdenied');
            return;
        }

        var id = this.tipodomanda.id; //se è la prima volta si prova a prendere da getid 

        if (id != null) {

            var token = localStorage.getItem('token');
            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/tipodomanda/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.tipodomanda = res[0];
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

    },
    mounted: function() { 
        
    }

}
</script>
